import { render } from "./GestioneAllegati.vue?vue&type=template&id=3fe04330&scoped=true"
import script from "./GestioneAllegati.vue?vue&type=script&lang=js"
export * from "./GestioneAllegati.vue?vue&type=script&lang=js"

import "./GestioneAllegati.vue?vue&type=style&index=0&id=3fe04330&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe04330"]])

export default __exports__